var map = {
	"./Basic_OCA_package.json": 4292,
	"./ContextHub_project_catalogue_record_OCA_package.json": 5664,
	"./ContextHub_questionnaire_catalogue_record_OCA_package.json": 5344,
	"./ContextHub_schema_catalogue_record_OCA_package.json": 7086,
	"./Dublin_Core_Project_OCA_package.json": 9744,
	"./Dublin_Core_Repository_OCA_package.json": 1121,
	"./OpenAIRE_OCA_package.json": 7651,
	"./Project_schema_v2.json": 305,
	"./cataloguerecord_DCAT.top_OCA_package.json": 368,
	"./schema_catalogue_record_OCA_package.json": 1873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6952;